var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhotopoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2700_5171)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 13.25C12.2426 13.25 13.25 12.2426 13.25 11C13.25 9.75736 12.2426 8.75 11 8.75C9.75736 8.75 8.75 9.75736 8.75 11C8.75 12.2426 9.75736 13.25 11 13.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 5H14.6225L13.6925 3.9875C13.415 3.68 13.01 3.5 12.59 3.5H9.41C8.99 3.5 8.585 3.68 8.3 3.9875L7.3775 5H5C4.175 5 3.5 5.675 3.5 6.5V15.5C3.5 16.325 4.175 17 5 17H17C17.825 17 18.5 16.325 18.5 15.5V6.5C18.5 5.675 17.825 5 17 5ZM11 14.75C8.93 14.75 7.25 13.07 7.25 11C7.25 8.93 8.93 7.25 11 7.25C13.07 7.25 14.75 8.93 14.75 11C14.75 13.07 13.07 14.75 11 14.75Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2700_5171"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotopoint);
export default __webpack_public_path__ + "static/media/photopoint.80f306703978cb4dd61ad09e152869e7.svg";
export { ForwardRef as ReactComponent };